import { AlertTriangle, X } from 'lucide-react'
import { useState } from 'react'
import { Button } from './ui/button'

export function IdentityWarning() {
  const [dismissed, setDismissed] = useState(false)

  if (dismissed) {
    return null
  }

  return (
    <div className="border-b border-yellow-500/50 bg-yellow-500/10 px-4 py-2">
      <div className="container mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <AlertTriangle className="h-4 w-4 text-yellow-600 dark:text-yellow-500" />
          <p className="text-xs text-yellow-800 dark:text-yellow-200">
            Unable to fetch user identity. You may not be properly authenticated with Cloudflare
            Access.
          </p>
        </div>
        <Button
          variant="ghost"
          size="icon"
          className="h-6 w-6 text-yellow-800 hover:bg-yellow-500/20 dark:text-yellow-200"
          onClick={() => setDismissed(true)}
          aria-label="Dismiss warning"
        >
          <X className="h-3 w-3" />
        </Button>
      </div>
    </div>
  )
}
